import { ActivatedRoute } from '@angular/router';

/**
 * Enum com as possiveis 'Action's.
 */
export enum Action {
  LIST = 'list',
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

/**
 * Classe de controle 'Action'.
 */
export class ActionSystem {
  private action: Action;

  constructor(route?: ActivatedRoute) {
    if (route !== null && route !== undefined) {
      let data = route.snapshot.data;

      for (let index of Object.keys(data)) {
        let param = data[index];

        if (
          param !== null &&
          typeof param === 'object' &&
          param['action'] !== undefined
        ) {
          this.action = param['action'];
          break;
        }
      }
    }
  }

  /**
   * Seta o valor da ação vigente.
   *
   * @param action
   */
  public setAction(action: Action): ActionSystem {
    this.action = action;
    return this;
  }

  /**
   * Verifica se ação é referente a 'INCLUIR'.
   *
   * @return boolean
   */
  public isCreateAction(): boolean {
    return Action.CREATE == this.action;
  }

  /**
   * Verifica se ação é referente a 'ALTERAR'.
   *
   * @return boolean
   */
  public isEditAction(): boolean {
    return Action.EDIT == this.action;
  }

  /**
   * Verifica se ação é referente a 'LISTAR'.
   *
   * @return boolean
   */
  public isListAction(): boolean {
    return Action.LIST == this.action;
  }

  /**
   * Verifica se ação é referente a 'CONSULTAR'.
   *
   * @return boolean
   */
  public isViewAction(): boolean {
    return Action.VIEW == this.action;
  }
}
